<template>
    <div class="container">
        <FullPageLoading
            :show="showLoading"
            :label="labelLoading"
        />
        <div class="messaging">
            <div class="inbox_msg">
                <div class="inbox_people">
                    <div class="headind_srch">
                        <div class="recent_heading">
                            <h4>Recent</h4>
                        </div>
                        <div class="srch_bar">
                            <div class="stylish-input-group">
                                <vue-select :options="optionsList" v-model="form.person" :searchable="true" @input="createConversation" @search="fetchOptions" placeholder="Search persons here ..">
                                </vue-select>
                            </div>
                        </div>
                    </div>
                    <div class="inbox_chat">
                        <div class="chat_list" v-if="c !== null" v-for="(c, index) in conversation" :key="c.id">
                            <div class="chat_people" style="cursor: pointer;" @click="chooseChat(c.id)">
                                <div v-for="(cc, indexx) in c.participants" :key="indexx" v-if="cc.id !== dataUser.id">
                                    <div class="chat_img"> 
                                        <img :src="cc.photo_profile" :alt="c.participants[1].full_name">
                                    </div>
                                    <div class="chat_ib">
                                        <h5>{{ cc.full_name }} <span class="chat_date" v-if="c.last_message !== null">{{ c.last_message.created_at | dateChat }}</span></h5>
                                        <p v-if="c.last_message !== null">{{ c.last_message.body }}</p>
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div class="chat_list" v-else="c !== null">
                            <h3>No Message Found.</h3>
                        </div>
                    </div>
                </div>
                <div class="mesgs">
                    <div class="msg_history">
                        <div v-if="conversationId !== null">
                            <infinite-loading direction="top" @infinite="infiniteHandler">
                                <span slot="no-more">
                                    <!-- <div class="card">
                                        <div class="card__content">
                                            <div class="card__content__status" style="white-space: pre-line;">
                                                <h5 class="m-0">You already reach the top of your message!</h5>
                                            </div>
                                        </div>
                                    </div> -->
                                </span>
                                <span slot="no-results">
                                    <!-- <div class="card">
                                        <div class="card__content">
                                            <div class="card__content__status" style="white-space: pre-line;">
                                                <h5 class="m-0">You already reach the top of your message!</h5>
                                            </div>
                                        </div>
                                    </div> -->
                                </span>
                            </infinite-loading>
                            <div v-for="(m, index) in conversationOne" :key="index">
                                <div class="incoming_msg" v-if="m.user_id !== dataUser.id">
                                    <div class="incoming_msg_img">
                                        <img :src="m.sender.photo_profile" :alt="m.sender.full_name">
                                    </div>
                                    <div class="received_msg">
                                        <div class="received_withd_msg">
                                            <p>{{ m.body }}</p>
                                            <span class="time_date">{{ m.created_at | messageDate }}</span>
                                        </div>
                                    </div>
                                </div>
                                <div class="outgoing_msg" v-if="m.user_id === dataUser.id">
                                    <div class="sent_msg">
                                        <p>{{ m.body }}</p>
                                        <span class="time_date">{{ m.created_at | messageDate }}</span>
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div v-if="conversationId === null" class="text-center begin_chat_wrapper">
                            <div class="begin_chat">
                                <img src="@/assets/img/begin_chat.png" alt="Begin Chat" width="300">
                                <p class="text-secondary">Choose the person you're going to chat with on the left pane</p>
                            </div>
                        </div>
                    </div>
                    <div class="type_msg">
                        <div class="input_msg_write">
                            <input type="text" class="write_msg form-control" placeholder="Type a message" :disabled="conversationId === null" v-model="form.message" @keyup.enter="createMessage" />
                            <button class="msg_send_btn" type="button" :disabled="conversationOne.length < 1" @click="createMessage"><i class="fas fa-paper-plane" aria-hidden="true"></i></button>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import vue2Dropzone from 'vue2-dropzone'
import moment from 'moment'
import 'vue2-dropzone/dist/vue2Dropzone.min.css'
import VEmojiPicker from 'v-emoji-picker';
import packData from 'v-emoji-picker/data/emojis.json';
import axios from 'axios'
import InfiniteLoading from 'vue-infinite-loading';
import FullPageLoading from './FullPageLoading.vue'
import VueGallerySlideshow from 'vue-gallery-slideshow';
import VueTagsInput from '@johmun/vue-tags-input';
import vSelect from 'vue-select';
import 'vue-select/dist/vue-select.css';

export default {
    components: {
        vueDropzone: vue2Dropzone,
        VEmojiPicker,
        FullPageLoading,
        InfiniteLoading,
        VueGallerySlideshow,
        VueTagsInput,
        'vue-select': vSelect
    },
    data() {
        return {
            showLoading: false,
            labelLoading: 'Please Wait...',
            conversation: [],
            conversationOne: [],
            conversationId: null,
            page: 1,
            form: {
                person: '',
            },
            optionsList: [],
            debounce: null,
        }
    },
    watch: {
        'tags': 'initItems',
    },
    computed: {
        isLogin: function () {
            return this.$store.state.isLogin;
        },
        dataUser: function () {
            if (this.isLogin) {
                return this.$store.state.dataUser;
            } else {
                return [];
            }
        },
    },
    filters: {
        dateChat: function(val) {
            return moment(val, 'YYYY-MM-DD HH:mm:ss').format('MMM DD');
        },
        messageDate: function(val) {
            return moment(val, 'YYYY-MM-DD HH:mm:ss').format('H:mm A MMM DD');
        },
    },
    created() {
        this.loadAllMessage();
    },
    methods: {
        async loadAllMessage() {
            this.conversation = [];
            this.showLoading = true;
            this.labelLoading = 'Loading Message! Please Wait...';

            let payload = {
                scope: 'load',
                data: {
                    access_token: this.dataUser.access_token,
                },
            };

            try {
                let load = await this.$store.dispatch('message', payload);
                if (load.data.status) {
                    this.conversation = load.data.data;
                    this.unreadAll();
                    this.showLoading = false;
                } else {
                    this.showLoading = false;
                    this.$bvToast.toast('Load Message Failed! Please refresh the page!', {
                        title: 'Failed',
                        variant: 'warning',
                        autoHideDelay: 2000,
                    });
                }
            } catch (err) {
                this.showLoading = false;
                this.$bvToast.toast('Load Message Failed! Please refresh the page!', {
                    title: 'Failed',
                    variant: 'warning',
                    autoHideDelay: 2000,
                });
            }
        },
        async unreadAll() {
            let conversation_id = [];
            this.conversation.forEach((c) => {
                conversation_id.push(c.last_message.conversation_id);
            });

            let payload = {
                scope: 'unreadMessage',
                data: {
                    access_token: this.dataUser.access_token,
                    conversation_id: conversation_id,
                },
            };

            try {
                let load = await this.$store.dispatch('message', payload);
            } catch (err) {
                this.showLoading = false;
                this.$bvToast.toast('Load Message Failed! Please refresh the page!', {
                    title: 'Failed',
                    variant: 'warning',
                    autoHideDelay: 2000,
                });
            }
        },
        async chooseChat(id) {
            this.conversationId = id;
            this.conversationOne = [];
            this.showLoading = true;
            this.labelLoading = 'Loading Message! Please Wait...';

            let payload = {
                scope: 'loadOne',
                data: {
                    access_token: this.dataUser.access_token,
                    conversation_id: this.conversationId,
                    page: 1,
                },
            };

            try {
                let load = await this.$store.dispatch('message', payload);
                if (load.data.status) {
                    if (load.data.data.data.length > 0) {
                        load.data.data.data.forEach((m) => {
                            this.conversationOne.push(m);
                        });
                    }
                    this.showLoading = false;
                } else {
                    this.showLoading = false;
                    this.$bvToast.toast('Load Message Failed! Please refresh the page!', {
                        title: 'Failed',
                        variant: 'warning',
                        autoHideDelay: 2000,
                    });
                }
            } catch (err) {
                this.showLoading = false;
                this.$bvToast.toast('Load Message Failed! Please refresh the page!', {
                    title: 'Failed',
                    variant: 'warning',
                    autoHideDelay: 2000,
                });
            }
        },
        async infiniteHandler($state) {
            this.page += 1;

            let payload = {
                scope: 'loadOne',
                data: {
                    access_token: this.dataUser.access_token,
                    conversation_id: this.conversationId,
                    page: this.page,
                },
            };

            try {
                let load = await this.$store.dispatch('message', payload);
                if (load.data.status) {
                    if (load.data.data.data.length > 0) {
                        load.data.data.data.forEach((m) => {
                            this.conversationOne.push(m);
                        });
                        $state.loaded();
                    } else {
                        this.page -= 1;
                        $state.complete();
                    }
                } else {
                    this.page -= 1;
                    $state.error();
                    if (load.data.message !== 'Invalid API Request') {
                        this.$bvToast.toast('Load Message Failed! Please Refresh the page!', {
                            title: 'Failed',
                            variant: 'warning',
                            autoHideDelay: 2000,
                        });
                    }
                }
            } catch (err) {
                this.page -= 1;
                $state.error();
                this.$bvToast.toast('Load Message Failed! Please Refresh the page!', {
                    title: 'Failed',
                    variant: 'warning',
                    autoHideDelay: 2000,
                });
            }
        },
        async createMessage() {
            this.showLoading = true;
            this.labelLoading = 'Sending Message! Please Wait...';

            let payload = {
                scope: 'send',
                data: {
                    access_token: this.dataUser.access_token,
                    conversation_id: this.conversationId,
                    message: this.form.message,
                    type: 'text',
                    user_id: this.dataUser.id,
                },
            };

            try {
                let load = await this.$store.dispatch('message', payload);
                if (load.data.status) {
                    this.form.message = '';
                    if (typeof load.data.data.message !== 'undefined') {
                        this.conversationOne.push(load.data.data.message);
                    }
                    this.showLoading = false;
                } else {
                    this.form.message = '';
                    this.showLoading = false;
                    this.$bvToast.toast('Send Message Failed! Please refresh the page!', {
                        title: 'Failed',
                        variant: 'warning',
                        autoHideDelay: 2000,
                    });
                }
            } catch (err) {
                this.form.message = '';
                this.showLoading = false;
                this.$bvToast.toast('Send Message Failed! Please refresh the page!', {
                    title: 'Failed',
                    variant: 'warning',
                    autoHideDelay: 2000,
                });
            }
        },
        async createConversation() {
            this.autocompleteItems = [];
            this.personTag = [];

            this.showLoading = true;
            this.labelLoading = 'Creating new Conversations! Please Wait...';

            let payload = {
                scope: 'create',
                data: {
                    access_token: this.dataUser.access_token,
                    participants: [this.dataUser.id, this.form.person.code]
                },
            };

            try {
                let load = await this.$store.dispatch('message', payload);
                if (load.data.status) {
                    this.autocompleteItems = [];
                    this.optionsList = [];
                    this.personTag = [];
                    this.form.person = '';
                    this.loadAllMessage();
                    this.showLoading = false;
                } else {
                    this.autocompleteItems = [];
                    this.optionsList = [];
                    this.personTag = [];
                    this.form.person = '';
                    this.showLoading = false;
                    this.$bvToast.toast('Creating new Conversations Failed! Please Choose other than yourself!', {
                        title: 'Failed',
                        variant: 'warning',
                        autoHideDelay: 2000,
                    });
                }
            } catch (err) {
                this.autocompleteItems = [];
                this.optionsList = [];
                this.personTag = [];
                this.form.person = '';
                this.showLoading = false;
                this.$bvToast.toast('Creating new Conversations Failed! Please refresh the page!', {
                    title: 'Failed',
                    variant: 'warning',
                    autoHideDelay: 2000,
                });
            }
        },
        fetchOptions(search, loading) {
            loading(true);
            let payload = {
                scope: 'search',
                data: {
                    access_token: this.dataUser.access_token,
                    filter: {
                        q: search
                    },
                },
            };

            clearTimeout(this.debounce);
            this.debounce = setTimeout(async() => {
                try {
                    let post = await this.$store.dispatch('post', payload);
                    this.optionsList = post.data.message.map(a => {
                        return { label: a.full_name, code: a.id };
                    });
                    loading(false);
                } catch (err) {
                    this.$bvToast.toast('Search Person Failed! Please Refresh the Page!', {
                        title: 'Failed',
                        variant: 'warning',
                        autoHideDelay: 2000,
                    });
                    loading(false);
                }
            }, 600);
        },
    }
}
</script>

<style scoped>
.container {
    max-width: 1170px;
    margin: auto;
}

.begin_chat_wrapper {
    position: relative;
}
.begin_chat {
    position: absolute;
    left: 50%;
    margin-top: 5em;
    transform: translateX(-50%);
}

img {
    max-width: 100%;
}

.inbox_people {
    background: #f8f8f8 none repeat scroll 0 0;
    float: left;
    width: 40%;
    border-right: 1px solid #c4c4c4;
    overflow: hidden;
}

.inbox_msg {
    border: 1px solid #c4c4c4;
    overflow: hidden;
    clear: both;
}

.top_spac {
    margin: 20px 0 0;
}

.recent_heading {
    float: left;
    width: 40%;
}

.srch_bar {
    display: inline-block;
    text-align: right;
    width: 60%;
}

.headind_srch {
    padding: 10px 29px 10px 20px;
    border-bottom: 1px solid #c4c4c4;
}

.recent_heading h4 {
    color: #267ABF;
    font-size: 21px;
    margin: auto;
}

.srch_bar input {
    border: 1px solid #cdcdcd;
    border-width: 0 0 1px 0;
    width: 80%;
    padding: 2px 0 4px 6px;
    background: none;
}

.srch_bar .input-group-addon button {
    background: rgba(0, 0, 0, 0) none repeat scroll 0 0;
    border: medium none;
    padding: 0;
    color: #707070;
    font-size: 18px;
}

.srch_bar .input-group-addon {
    margin: 0 0 0 -27px;
}

.chat_ib h5 {
    font-size: 15px;
    color: #464646;
    margin: 0 0 8px 0;
}

.chat_ib h5 span {
    font-size: 13px;
    float: right;
}

.chat_ib p {
    font-size: 14px;
    color: #989898;
    margin: auto
}

.chat_img{
    float: left;
    width: 11%;
}

.chat_img img {
    border-radius: 50%;
    vertical-align: middle;
}

.chat_ib {
    float: left;
    padding: 0 0 0 15px;
    width: 88%;
}

.chat_people {
    overflow: hidden;
    clear: both;
}

.chat_list {
    border-bottom: 1px solid #c4c4c4;
    margin: 0;
    padding: 18px 16px 10px;
}

.inbox_chat {
    height: 550px;
    overflow-y: scroll;
}

.active_chat {
    background: #ebebeb;
}

.incoming_msg_img {
    display: inline-block;
    width: 6%;
}

.received_msg {
    display: inline-block;
    padding: 0 0 0 10px;
    vertical-align: top;
    width: 92%;
}

.received_withd_msg p {
    background: #ebebeb none repeat scroll 0 0;
    border-radius: 3px;
    color: #646464;
    font-size: 14px;
    margin: 0;
    padding: 5px 10px 5px 12px;
    width: 100%;
}

.time_date {
    color: #747474;
    display: block;
    font-size: 12px;
    margin: 8px 0 0;
}

.received_withd_msg {
    width: 57%;
}

.mesgs {
    float: left;
    padding: 30px 15px 0 25px;
    width: 60%;
}

.sent_msg p {
    background: #267ABF none repeat scroll 0 0;
    border-radius: 3px;
    font-size: 14px;
    margin: 0;
    color: #fff;
    padding: 5px 10px 5px 12px;
    width: 100%;
}

.outgoing_msg {
    overflow: hidden;
    margin: 26px 0 26px;
}

.sent_msg {
    float: right;
    width: 46%;
}

.input_msg_write input {
    background: rgba(0, 0, 0, 0) none repeat scroll 0 0;
    border: medium none;
    color: #4c4c4c;
    font-size: 15px;
    min-height: 48px;
    width: 100%;
}

.type_msg {
    border-top: 1px solid #c4c4c4;
    position: relative;
}

.msg_send_btn {
    background: #267ABF none repeat scroll 0 0;
    border: medium none;
    border-radius: 50%;
    color: #fff;
    cursor: pointer;
    font-size: 17px;
    height: 33px;
    position: absolute;
    right: 0;
    top: 11px;
    width: 33px;
}

.messaging {
    padding: 0 0 50px 0;
}

.msg_history {
    height: 516px;
    overflow-y: auto;
}

.write_msg {
    padding-right: 50px;
}
</style>